module.exports = __webpack_public_path__ + "82f4193e591837d6574da657f930b07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/Assets/vegehandserve.png
// module id = 1369
// module chunks = 0